import { FC, PropsWithChildren } from 'react';
import authImg from '@assets/auth-img.png';
import logo from '@assets/logo.svg';

export const AuthLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex justify-start items-start w-full h-screen box-border gap-24 p-5.25 md:p-10 auth-layout xl:pr-24.75 ">
      <div className="hidden xl:flex flex-none w-[45%]  relative auth-side-image h-full">
        <img src={authImg} alt="Auth" />
      </div>

      <div className="flex-1 h-full w-full flex flex-col box-border justify-between">
        <div className="self-center">
          <img src={logo} alt="Newlane University" className="h-10" />
        </div>
        {children}
      </div>
    </div>
  );
};
